<template>
  <div>
    <div class="pt-4">
      <router-link
        to="step1"
        class="bg-gray-700 rounded p-6 text-white font-bold text-2xl max-w-xs m-auto text-center mt-20 block"
      >Get Started</router-link>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$router.push('step1')
  },
}
</script>
